import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../../../consts/api";
import { http } from "../../../../services/HttpService";
import { uiNotification } from "../../../../services/UINotificationService";

const composeResponse = (res) => {
  const result = {
    card: {
      available: res.data.data.card?.available,
      maxAmount: res.data.data.card?.max_payable_amount,
    },
    cash: {
      available: res.data.data.cash?.available,
      maxAmount: res.data.data.cash?.max_payable_amount,
    },
    careCredit: {
      available: res.data.data.careCredit?.available,
      maxAmount: res.data.data.careCredit?.max_payable_amount,
    },
    cherry: {
      available: res.data.data.cherry?.available,
      balance: res.data.data.cherry?.available_balance,
    },
    check: {
      available: res.data.data.check?.available,
      maxAmount: res.data.data.check?.max_payable_amount,
    },
    giftCard: {
      available: res.data.data.giftCard?.available,
      maxAmount: res.data.data.giftCard?.max_payable_amount,
      warning: res.data.data.giftCard?.warning,
    },
    greenSky: {
      available: res.data.data.greensky?.available,
      maxAmount: res.data.data.greensky?.max_payable_amount,
    },
    klarna: {
      available: res.data.data.klarna?.available,
      maxAmount: res.data.data.klarna?.max_payable_amount,
    },
    text2pay: {
      available: res.data.data.text2pay?.available,
      maxAmount: res.data.data.text2pay?.max_payable_amount,
    },
    wallet: {
      available: res.data.data.wallet?.available,
      maxAmount: res.data.data.wallet?.max_payable_amount,
      warning: res.data.data.wallet?.warning,
      balance: res.data.data.wallet?.available_balance,
    },
    pfi: {
      available: res.data.data.pfi?.available,
      maxAmount: res.data.data.pfi?.max_payable_amount,
      warning: res.data.data.pfi?.unavailability_reason,
      minAmount: res.data.data.pfi?.min_payable_amount,
      availableBalance: res.data.data.pfi?.available_balance,
      disclaimer: res.data.data.pfi?.lowest_plan?.disclosure,
      lowestPayment: res.data.data.pfi?.lowest_plan?.lowestPayment,
    },
    sunbit: {
      available: res.data.data.sunbit?.available,
      disclaimer: res.data.data.sunbit?.disclaimer,
    },
    affirm: {
      available: res.data.data.affirm?.available,
    },
  };
  return result;
};

export const useAvailablePaymentMethods = (invoiceId, options) => {
  return useQuery(
    ["availablePaymentMethods"],
    async () => {
      const res = await http.get(
        HTTP_ENDPOINTS.getAvailablePaymentMethods(invoiceId),
      );
      return composeResponse(res);
    },
    {
      onError: (err) => uiNotification.error(err.response.data.message),
      ...options,
    },
  );
};
